import React from "react";

export default class SchrankInput extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <fieldset>
                {this.props.children}
                {this.props.values.map((value, index) => (
                    <div
                        key={index}
                        className={
                            "productdrag image-text stop-select selectable " +
                            (this.props.isEqual
                                ? this.props.isEqual(value, this.props.value)
                                    ? "selected"
                                    : ""
                                : value === this.props.value
                                ? "selected"
                                : "")
                        }
                        onClick={() => this.props.onChange(value)}
                    >
                        <div className="image no-pointer" style={{ backgroundImage: "url(" + value.image + ")" }}></div>
                        <div className="text">{this.props.getLabel(value)}</div>
                    </div>
                ))}
            </fieldset>
        );
    }
}
